import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import {
  MainApp,
  RegistrationPage,
  LoginPage,
  ForgotPasswordPage,
  CoachingParticipantsPage,
  RefundPolicyPage,
  PrivacyPolicyPage,
} from "../../pages";

const Routes = () => {
  return (
    <Router>
      <Switch>
        <Route path="/coaching-program" exact>
          <CoachingParticipantsPage />
        </Route>
        <Route path="/login" exact>
          <LoginPage />
        </Route>
        <Route path="/registration" exact>
          <RegistrationPage />
        </Route>
        <Route path="/reset-password/:token" exact>
          <ForgotPasswordPage />
        </Route>
        <Route path="/kebijakan-pembatalan-refund" exact>
          <RefundPolicyPage />
        </Route>
        <Route path="/kebijakan-privasi" exact>
          <PrivacyPolicyPage />
        </Route>
        <Route path="/">
          <MainApp />
        </Route>
      </Switch>
    </Router>
  );
};

export default Routes;
